'use client'

import { memo } from 'react'
import { CraftShell } from '../_components/craft-shell'
import { NinxlEnterpriseHeroBackground } from '../_components/ninxl-enterprise-hero-background'
import { NinxlEnterpriseSection } from '../_components/ninxl-enterprise-section'

/** baby: Enterprise keeps section content; craft shell replaces 8bit chrome. */
const NinxlEnterprisePage = () => (
  <CraftShell>
    <NinxlEnterpriseHeroBackground />
    <main>
      <NinxlEnterpriseSection />
    </main>
  </CraftShell>
)

export default memo(NinxlEnterprisePage)
